import { render, staticRenderFns } from "./video-games.vue?vue&type=template&id=1817486a"
import script from "./video-games.vue?vue&type=script&lang=js"
export * from "./video-games.vue?vue&type=script&lang=js"
import style0 from "./video-games.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/video-games/video-games.vue
// module id = gPOj
// module chunks = 0